import * as styles from "./Background.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import { vars } from "@frontend/styles";

import type { BackgroundProps } from "./Background.types";
import { BackgroundBeams } from "./BackgroundBeams";
import { BackgroundPattern } from "./BackgroundPattern";
import {
  BACKGROUND_DEFAULT_EFFECT,
  BACKGROUND_DEFAULT_FADE,
  BACKGROUND_DEFAULT_POSITION,
  BEAMS_DEFAULT_COUNT,
  BEAMS_DEFAULT_DURATION_MS,
  BEAMS_DEFAULT_INTENSITY,
  BEAMS_DEFAULT_WIDTH,
  PATTERN_DEFAULT,
  PATTERN_DEFAULT_CELL_SIZE,
  PATTERN_DEFAULT_REPEL_RADIUS,
  PATTERN_DEFAULT_REPEL_STRENGTH,
  PATTERN_DEFAULT_SPOTLIGHT_SIZE,
} from "./constants";

export function Background({
  effect = BACKGROUND_DEFAULT_EFFECT,
  position = BACKGROUND_DEFAULT_POSITION,
  fade = BACKGROUND_DEFAULT_FADE,
  color,
  count = BEAMS_DEFAULT_COUNT,
  duration = BEAMS_DEFAULT_DURATION_MS,
  intensity = BEAMS_DEFAULT_INTENSITY,
  beamWidth = BEAMS_DEFAULT_WIDTH,
  rails = true,
  pattern = PATTERN_DEFAULT,
  cellSize = PATTERN_DEFAULT_CELL_SIZE,
  spotlight = true,
  spotlightSize = PATTERN_DEFAULT_SPOTLIGHT_SIZE,
  repel = true,
  repelRadius = PATTERN_DEFAULT_REPEL_RADIUS,
  repelStrength = PATTERN_DEFAULT_REPEL_STRENGTH,
  className,
  ...props
}: BackgroundProps): JSX.Element {
  // Beams are an accent, a pattern is a texture: they do not want the same
  // colour, so each effect falls back to its own.
  const resolvedColor =
    color ??
    (effect === "pattern"
      ? `${vars.color.textDisabled}`
      : `${vars.color.primary}`);

  return (
    <div
      data-slot="background"
      data-effect={effect}
      aria-hidden="true"
      className={clsx(styles.root({ position }), styles.fade[fade], className)}
      {...props}
    >
      {effect === "beams" && (
        <BackgroundBeams
          color={resolvedColor}
          count={count}
          duration={duration}
          intensity={intensity}
          beamWidth={beamWidth}
          rails={rails}
        />
      )}

      {effect === "pattern" && (
        <BackgroundPattern
          pattern={pattern}
          color={resolvedColor}
          cellSize={cellSize}
          intensity={intensity}
          spotlight={spotlight}
          spotlightSize={spotlightSize}
          repel={repel}
          repelRadius={repelRadius}
          repelStrength={repelStrength}
        />
      )}
    </div>
  );
}
